import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { today, dateFns } from 'constants/index'
import { getDateWithClientTimezone } from 'utils/date'

export function useExportHistoryFilters() {
  const [searchParams, setSearchParams] = useSearchParams()

  const status = searchParams.get('status')?.split(',') ?? undefined
  const startDate =
    searchParams.get('startDate') ?? getDateWithClientTimezone(dateFns.startOfWeek(today)).clientWithTimezone
  const endDate = searchParams.get('endDate') ?? getDateWithClientTimezone(dateFns.endOfDay(today)).clientWithTimezone
  const startExportPeriod = searchParams.get('startExportPeriod') ?? undefined
  const endExportPeriod = searchParams.get('endExportPeriod') ?? undefined
  const page = searchParams.get('page') ?? 1
  const pageSize = searchParams.get('pageSize') ?? 10

  const setFilters = useCallback(
    (filters) => {
      setSearchParams((params) => {
        if (filters.status?.length) params.set('status', filters.status)
        else params.delete('status')

        if (filters.startDate) params.set('startDate', filters.startDate)
        else params.delete('startDate')

        if (filters.endDate) params.set('endDate', filters.endDate)
        else params.delete('endDate')

        if (filters.startExportPeriod) params.set('startExportPeriod', filters.startExportPeriod)
        else params.delete('startExportPeriod')

        if (filters.endExportPeriod) params.set('endExportPeriod', filters.endExportPeriod)
        else params.delete('endExportPeriod')

        return params
      })
    },
    [setSearchParams],
  )

  const setPage = useCallback(
    (pageParams) => {
      setSearchParams((params) => {
        params.set('page', pageParams.page)
        params.set('pageSize', pageParams.pageSize)

        return params
      })
    },
    [setSearchParams],
  )

  const unsetFilters = useCallback(() => {
    setSearchParams((params) => {
      if (status) params.delete('status')
      if (startExportPeriod) params.delete('startExportPeriod')
      if (endExportPeriod) params.delete('endExportPeriod')

      return params
    })
  }, [setSearchParams, status, startExportPeriod, endExportPeriod])

  return {
    filters: {
      status,
      startDate,
      endDate,
      startExportPeriod,
      endExportPeriod,
      page,
      pageSize,
    },
    setFilters,
    setPage,
    unsetFilters,
  }
}
